import { Component } from '@angular/core';
import { CreateQuickProductLookupComponent } from "../create-quick-product-lookup/create-quick-product-lookup.component";
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { SharedModule } from '../../../shared/shared.module';

@Component({
  selector: 'app-close-quick-product-lookup',
  standalone: true,
  imports: [CreateQuickProductLookupComponent, SharedModule],
  templateUrl: './close-quick-product-lookup.component.html',
  styleUrl: './close-quick-product-lookup.component.scss'
})
export class CloseQuickProductLookupComponent {

  constructor(public ref: DynamicDialogRef){}

  close(data: any){
    this.ref.close(data);
  }

}
